import { intersection } from '../../lib/utils/array'

export const handleRuleResult = (rule, selectedOptions, recommendedProducts = []) => {
  let ruleApplies, intersects, matchesPartially, matchesFully = false

  if (rule.logic_condition.includes("PRODUCTS")) {
    // Logic condition based on recommended products
    intersects = intersection(rule.recommended_variants.map((p) => p.id), recommendedProducts.map((p) => p.id)).length
    matchesPartially =  intersects > 0
    matchesFully = intersects === rule.recommended_variants.length
  } else {
    // Logic condition based on user answers
    intersects = intersection(selectedOptions.map((o) => o.handle), rule.answers).length
    matchesPartially =  intersects > 0
    matchesFully = intersects === rule.answers.length
  }

  // Apply rule based on logic condition
  if (
    rule.logic_condition.includes("match ALL") && matchesFully
    || rule.logic_condition.includes("match SOME") && matchesPartially
    || rule.logic_condition.includes("DON'T match SOME") && !matchesPartially
    || rule.logic_condition.includes("DON'T match ALL") && !matchesFully
    || rule.logic_condition.includes("ALWAYS")
  ) {
    ruleApplies = true
  }

  if(ruleApplies && rule.logic_condition.includes("INCLUDE")) {
    return "INCLUDE"
  } else if (ruleApplies && rule.logic_condition.includes("EXCLUDE")) {
    return "EXCLUDE"
  }

  return;
}